import { AlarmInfo } from "./AlarmInfo";
export default AlarmInfo;
